import { css, cx } from "@emotion/css"
import React, { useRef, useState, useEffect } from "react"

import useBool from "../../hooks/useBool"

type Props = {
  isOpen: boolean
  children: React.ReactNode
}

const DropDown = ({ children, isOpen }: Props) => {
  const ref = useRef<HTMLDivElement>(null)
  const [contentHeight, setContentHeight] = useState<"auto" | number>("auto")

  useEffect(() => {
    if (!ref.current) return
    setContentHeight(ref.current.clientHeight)
  }, [])

  if (contentHeight === "auto") {
    return (
      <div style={{ opacity: 0, position: "fixed" }} ref={ref}>
        {children}
      </div>
    )
  }

  return (
    <Anime isOpen={isOpen} height={contentHeight}>
      {children}
    </Anime>
  )
}

export default DropDown

const styles = {
  base: css`
    overflow: hidden;
    transition: height 0.5s;
  `,
  start: css`
    height: 0px;
  `,
  closed: css`
    visibility: hidden;
  `,
}

const Anime = ({ children, isOpen, height }: { children: React.ReactNode; isOpen: boolean; height: number }) => {
  const [isAnimating, startAnimation, endAnimation] = useBool(false)

  const isInitialMount = useRef(true)
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false
    } else {
      startAnimation()
    }

    // 開閉状態が変更されときのみ実行します
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  const end = css`
    height: ${height}px;
  `

  const className = cx(styles.base, isOpen ? end : styles.start, !isAnimating && !isOpen && styles.closed)

  return (
    <div className={className} onTransitionEnd={endAnimation}>
      {children}
    </div>
  )
}
